import DataTable, { createTheme } from "react-data-table-component";
import { GoChevronDown } from "react-icons/go";
import { Loader } from "rsuite";

import { useConfig } from "../../../context/config-context";

import columns from "./columns";
import conditionalRowStyles from "./conditionalRowStyles";
import customStyles from "./customStyles";

export default function TableStat({
  className,
  tutoMode,
  stats,
  isLoading,
  limit,
  handleLimit,
  handleSort,
  handlePage,
}) {
  const siteConfig = useConfig();

  createTheme(
    siteConfig.themes.table.name,
    siteConfig.themes.table.customTheme
  );

  return (
    <div className={`w-full h-full rounded-lg ${className}`}>
      <DataTable
        columns={columns(siteConfig.utils.contracts)}
        className={`rounded-b-xl ${tutoMode ? "!pointer-events-none" : ""}`}
        data={stats || []}
        noDataComponent={
          <span className="w-full font-semibold text-center">
            {siteConfig.no_data}
          </span>
        }
        customStyles={customStyles}
        conditionalRowStyles={conditionalRowStyles}
        defaultSortFieldId={1}
        defaultSortAsc={false}
        sortIcon={<GoChevronDown className="ml-1" color="var(--light)" />}
        striped
        highlightOnHover
        pagination
        theme="solarized"
        paginationPerPage={limit}
        paginationRowsPerPageOptions={[25, 50, 100]}
        progressPending={isLoading}
        progressComponent={<Loader className="w-full text-center" />}
        paginationServer
        paginationDefaultPage={1}
        paginationServerOptions={{
          persistSelectedOnPageChange: true,
          persistSelectedOnSort: true,
        }}
        paginationTotalRows={stats.length || 0}
        onChangePage={async (page) => await handlePage(page)}
        onChangeRowsPerPage={async (newPerPage) =>
          await handleLimit(newPerPage)
        }
        sortServer
        onSort={async (column, sortDirection) =>
          await handleSort(
            `{"${column.sortfield}":${sortDirection === "desc" ? -1 : 1}}`
          )
        }
        dense
        paginationComponentOptions={{
          rowsPerPageText:
            siteConfig.components.table_stat.pagination.rowsPerPageText,
          rangeSeparatorText:
            siteConfig.components.table_stat.pagination.rangeSeparatorText,
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: "All",
        }}
      />
    </div>
  );
}
